// Defensive patch for Bootstrap 5 Tooltip during fast Blazor navigation/dispose.
// Prevents: TypeError: Cannot convert undefined or null to object
// from Tooltip internals when state/element is cleared.
(function () {
  function patch() {
    try {
      const bs = window.bootstrap;
      const Tooltip = bs && bs.Tooltip;
      if (!Tooltip || !Tooltip.prototype) return;

      const proto = Tooltip.prototype;

      // 1) Guard `_isWithActiveTrigger`
      const originalIsWithActiveTrigger = proto._isWithActiveTrigger;
      if (typeof originalIsWithActiveTrigger === 'function' && !originalIsWithActiveTrigger.__isPatched) {
        function wrappedIsWithActiveTrigger() {
          if (!this || !this._activeTrigger) return false;
          return originalIsWithActiveTrigger.call(this);
        }
        wrappedIsWithActiveTrigger.__isPatched = true;
        proto._isWithActiveTrigger = wrappedIsWithActiveTrigger;
      }

      // 2) Guard `dispose()` (common crash path: this._element is null)
      const originalDispose = proto.dispose;
      if (typeof originalDispose === 'function' && !originalDispose.__isPatched) {
        function wrappedDispose() {
          if (!this || !this._element) {
            // If Bootstrap already nulled the element, there isn't anything safe to clean up.
            return;
          }
          try {
            return originalDispose.apply(this, arguments);
          } catch {
            // Dispose should never take down app navigation.
            return;
          }
        }
        wrappedDispose.__isPatched = true;
        proto.dispose = wrappedDispose;
      }

      // 3) Guard `_disposePopper()` (called during hide/dispose)
      const originalDisposePopper = proto._disposePopper;
      if (typeof originalDisposePopper === 'function' && !originalDisposePopper.__isPatched) {
        function wrappedDisposePopper() {
          if (!this || !this._element) {
            return;
          }
          try {
            return originalDisposePopper.apply(this, arguments);
          } catch {
            return;
          }
        }
        wrappedDisposePopper.__isPatched = true;
        proto._disposePopper = wrappedDisposePopper;
      }
    } catch {
      // no-op
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patch);
  } else {
    patch();
  }
})();
